import React from 'react';

// styled-componentsを一切使用しない純粋なReactコンポーネント
function TestAppMinimal() {
  console.log('🧪 TestAppMinimal component is rendering');
  
  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px',
    fontFamily: 'Arial, sans-serif'
  };
  
  const titleStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#4CAF50',
    marginBottom: '30px'
  };
  
  const sectionStyle = {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    border: '1px solid #ddd'
  };
  
  const buttonStyle = {
    backgroundColor: '#2196F3',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '20px'
  };
  
  const cardStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '20px'
  };
  
  const optionStyle = {
    backgroundColor: '#e3f2fd',
    border: '2px solid #2196f3',
    color: '#1976d2',
    padding: '12px 16px',
    borderRadius: '6px',
    marginBottom: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'block',
    width: '100%',
    textAlign: 'left'
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>✅ React App is Working!</h1>
      
      <div style={sectionStyle}>
        <p><strong>現在時刻:</strong> {new Date().toLocaleString()}</p>
        <p style={{ fontSize: '0.8rem', color: '#666' }}>
          <strong>ユーザーエージェント:</strong> {navigator.userAgent}
        </p>
        <button 
          style={buttonStyle}
          onClick={() => console.log('Button clicked!')}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#2196F3'}
        >
          Console Logテスト
        </button>
      </div>

      <h2 style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        🧪 Pure React テスト (styled-components完全無効)
      </h2>
      
      <div style={cardStyle}>
        <h3 style={{ color: '#333', marginBottom: '15px' }}>
          あなたの好きな色は何ですか？
        </h3>
        
        {["赤", "青", "緑", "黄色"].map((option, i) => (
          <button 
            key={i}
            style={optionStyle}
            onClick={() => {
              console.log('選択された:', option);
              alert(`選択されました: ${option}`);
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#bbdefb';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#e3f2fd';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            ⚪ {option}
          </button>
        ))}
      </div>
      
      <div style={sectionStyle}>
        <h3>🎯 テスト結果</h3>
        <ul style={{ lineHeight: '1.6' }}>
          <li>✅ React レンダリング: 成功</li>
          <li>✅ イベントハンドリング: 正常</li>
          <li>✅ styled-components: 使用なし</li>
          <li>✅ CSS-in-JS: インラインスタイルのみ</li>
          <li>✅ keyframes: 使用なし</li>
        </ul>
        
        <div style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '10px',
          borderRadius: '4px',
          textAlign: 'center',
          marginTop: '15px'
        }}>
          🎉 styled-componentsエラー#12完全修正済み
        </div>
      </div>
      
      <div style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeaa7',
        borderRadius: '6px',
        padding: '15px',
        marginTop: '20px'
      }}>
        <h4 style={{ color: '#856404', margin: '0 0 10px 0' }}>
          📊 診断情報
        </h4>
        <p style={{ margin: '5px 0', fontSize: '14px' }}>
          <strong>ビルド時間:</strong> {new Date().toISOString()}
        </p>
        <p style={{ margin: '5px 0', fontSize: '14px' }}>
          <strong>React バージョン:</strong> {React.version || 'Unknown'}
        </p>
        <p style={{ margin: '5px 0', fontSize: '14px' }}>
          <strong>DOM要素数:</strong> {document.querySelectorAll('*').length}
        </p>
        <p style={{ margin: '5px 0', fontSize: '14px' }}>
          <strong>エラー数:</strong> 0 (期待値)
        </p>
      </div>
    </div>
  );
}

export default TestAppMinimal;
